import React from 'react';
import T from 'prop-types';
// components
import ImageTag from './ImageTag';
import ImageTagTooltip from './ImageTagTooltip';
// utils
import classnames from 'classnames/bind';
// styles
import styles from './ImageTagView.module.scss';

const cn = classnames.bind(styles);

const ImageTagView = ({ tag }) => (
  <ImageTag tag={tag} hasHover hasCoordsUpdate>
    {({ tooltipOffset, triangleOffset, position }) => (
      <ImageTagTooltip
        tooltipOffset={tooltipOffset}
        triangleOffset={triangleOffset}
        isVisible
        position={position || 'top'}
      >
        <div className={cn('diagnosis-line')}>
          <i className={cn('fa fa-label', 'tag-label-icon')} />
          <span className={cn('diagnosis-name')}>
            {tag.diagnosis.label || tag.diagnosis.common_name || tag.diagnosis.name}
          </span>
        </div>
      </ImageTagTooltip>
    )}
  </ImageTag>
);

ImageTagView.contextTypes = {};

ImageTagView.propTypes = {
  tag: T.object,
};

export default ImageTagView;
